// Centralized API configuration
// In production, set REACT_APP_API_URL in your .env.production file
export const API_BASE_URL =
  process.env.REACT_APP_API_URL || 'http://localhost:8080/api/v1';
